var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2373,
    viewBox: "-13.73499479 -4.38055278 539.01318831 520.27162413",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 140h228a256 256 0 0 1 -240 371.7",
    fill: "#fc4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m357 314-113 197.7a256 256 0 0 1 -204-393.7",
    fill: "#0f9d58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 140h228a256 256 1 0 0 -444-22l115 196",
    fill: "#db4437"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#4285f4",
    r: 105,
    stroke: "#f1f1f1",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLogo);
export default __webpack_public_path__ + "static/media/chrome_logo.c52f667c1bdc76575c7d5b58d6695a02.svg";
export { ForwardRef as ReactComponent };